import { render } from "./NewsFilter.vue?vue&type=template&id=811a5d26&scoped=true"
import script from "./NewsFilter.vue?vue&type=script&lang=js"
export * from "./NewsFilter.vue?vue&type=script&lang=js"

import "./NewsFilter.vue?vue&type=style&index=0&id=811a5d26&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811a5d26"]])

export default __exports__